const ACCENT = "#e4206b"
const MUTED = "rgba(255,255,255,0.25)"

export default function StarRating({ rate, my = false }: { rate: number; my?: boolean }) {
    return (
        <div className="flex items-center gap-0.5" aria-label={`Оценка ${rate} из 5`}>
            {Array.from({ length: 5 }, (_, i) => {
                const filled = i < rate
                const color = filled ? (my ? ACCENT : "#349be6") : MUTED
                return (
                    <svg key={i} width="16" height="16" viewBox="0 0 16 16" fill={color} aria-hidden>
                        <path d="M8 1.5l1.76 3.57 3.94.57-2.85 2.78.67 3.93L8 10.67l-3.52 1.85.67-3.93L2.3 5.64l3.94-.57L8 1.5z" />
                    </svg>
                )
            })}
        </div>
    )
}
